import {
  GET_BEST_OFFERS_SUCCEEDED,
  GET_BEST_OFFERS_FAILED,
  GET_BEST_OFFERS,
  USER_RESET_PERSONAL_OPTIONS,
  USER_UPDATED_BEST_OFFER_STATE,
  USER_RESET_TERM_MILEAGE,
  INITIAL_DOWN_PAYMENT_LOADED,
  INITIAL_DOWN_PAYMENT_RESET
} from '../constants';
import { get, setWith, cloneDeep } from '../../utils';

const initialState = {
  loading: false,
  offers: {},
  error: null,
  userValues: {
    LEASE: {},
    FINANCE: {}
  },
  firstLoad: true
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {

    case GET_BEST_OFFERS:
      return {
        ...state,
        loading: true
      };

    case GET_BEST_OFFERS_SUCCEEDED: {
      const newState = {
        ...state
      };
      let offers = {
        ...state.bestOffers
      };
      offers = action.offers.options;
      newState.loading = false;
      newState.offers = offers;
      newState.userValues.LEASE.selectedTerm = !newState.userValues.LEASE.selectedTerm ? get(newState, 'offers.bestLeaseOffer.term') : newState.userValues.LEASE.selectedTerm;
      newState.userValues.LEASE.selectedMileage = !newState.userValues.LEASE.selectedMileage ? get(newState, 'offers.bestLeaseOffer.mileage') : newState.userValues.LEASE.selectedMileage;
      newState.userValues.FINANCE.selectedTerm = !newState.userValues.FINANCE.selectedTerm ? get(newState, 'offers.bestFinanceOffer.term') : newState.userValues.FINANCE.selectedTerm;
      newState.userValues.FINANCE.selectedOfferType = !newState.userValues.FINANCE.selectedOfferType ? 'bestAPR' : newState.userValues.FINANCE.selectedOfferType;
      newState.userValues.FINANCE.selectedFinanceDropdown = !newState.userValues.FINANCE.selectedFinanceDropdown ? 'Best APR' : newState.userValues.FINANCE.selectedFinanceDropdown;

      return newState;
    }

    case GET_BEST_OFFERS_FAILED:
      return {
        ...state,
        loading: false,
        offers: {},
        error: action.error
      };

    case USER_RESET_PERSONAL_OPTIONS: {
      const resetState = {
        ...state
      };

      resetState.userValues.LEASE = {};
      resetState.userValues.FINANCE = {};
      resetState.firstLoad = true;

      return resetState;
    }

    case USER_UPDATED_BEST_OFFER_STATE: {
      const newState = cloneDeep(state);
      const originalOptions = get(state, `userValues.${action.paymentType}`);
      const newOptions = {
        ...originalOptions,
        ...action.options
      };

      setWith(newState, `userValues.${action.paymentType}`, newOptions);
      return newState;
    }

    case USER_RESET_TERM_MILEAGE: {
      const resetState = {
        ...state
      };

      resetState.userValues.LEASE = {};
      resetState.userValues.FINANCE = {};

      return resetState;
    }

    case INITIAL_DOWN_PAYMENT_LOADED: {
      const newState = {
        ...state
      };
      newState.firstLoad = false;
      return newState;
    }

    case INITIAL_DOWN_PAYMENT_RESET: {
      const newState = {
        ...state
      };
      newState.firstLoad = true;
      return newState;
    }

    default:
      return state;
  }
}



/** WEBPACK FOOTER **
 ** ./src/redux/reducers/bestOffers.js
 **/